/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import Grid from './grid'
import useQuickIdeas from './use-quick-ideas'
import { Disclosures, Loading } from '../../twd'


export default () => {

    const { status, data, onViewAll } = useQuickIdeas({
        id: 'QUICK_IDEAS_MOST_ACTIVE',
        url: '/esb/retailservice/quickIdeasService/getMostActivelyTraded',
        params: {
            state: null,
            quickPickGroupSubTypeList: ['QUICK_IDEAS_MOST_ACTIVELY_TRADED_CORPS']
        },
        rowCount:3
    })


    return <React.Fragment>
        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-md-12 col-xs-12">
            <h3 style={{display:'inline-block', paddingRight:'10px'}} className="medium-header">Most Actively Traded</h3>
            <Disclosures
                dataModule='overview-quick-ideas'
                dataCategory='most-actively-traded'
                dataName='overview-quick-ideas-most-actively-traded-learn-more-link'
                label='Learn more'
                html={DISCLOSURES} />
            <p className="text-body"></p>
        </div></div>

        <div className="row vertical-offset-sm">
            <div className="col-md-10 col-xs-12">
            The most actively traded corporate bonds based on FINRA TRACE reported trades.
            </div>
            <div className="col-md-2 col-xs-12 text-right">
            <a href='#'
                data-module='overview-quick-ideas'
                data-category='most-actively-traded'
                data-name='overview-quick-ideas-most-actively-traded-view-all-link'
                style={{cursor:'pointer'}}
                onClick={() => {
                    let searchParams = {
                        holdInvType: ['C'],
                        holdMoodyRatingMin: 'Baa3',
                        holdSpRatingMin: 'BBB-',
                        offeringType: ['ask-side'],
                        persistToPreviousSearches: false,
                        sort: [{ field:'traceTradeCount', direction:'DESC' }]
                    }
                    onViewAll({searchParams})
                }}
            >View all</a>
            </div>
        </div>

        <div className="row"><div className="col-md-12">
        <Loading status={status}>
            <Grid
            dataCategory='most-actively-traded'
            dataName='overview-quick-ideas-most-actively-traded'
            rows={data} />
        </Loading>
        </div></div>

    </React.Fragment>
}

const DISCLOSURES = `
    <p>
    This category features actively traded investment-grade corporate bond
    search results based upon TRACE Market Aggregate Information.
    </p>`
